import styled from "styled-components";

export const Icon = styled.img`
  cursor: pointer;
`;
